import React from 'react';
import { withStyles } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Menu, { MenuProps } from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import DraftsIcon from '@mui/icons-material/Drafts';
import SendIcon from '@mui/icons-material/Send';
import { Timeline } from '@mui/icons-material';

interface IContextMenuWebProps {}

const StyledMenu = (props: MenuProps) => (
    <Menu
        elevation={0}
        anchorEl={null}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center'
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'center'
        }}
        {...props}
    />
);

const StyledMenuItem = MenuItem;

interface IContextMenuWeb {
    anchorEl?: any;
    itemname?: string;
    trendparam?: string;
}

export default function ContextMenuWeb(props: IContextMenuWeb) {
    const [anchorEl, setAnchorEl] = React.useState(props.anchorEl);

    const handleClick = (event: any) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    let openTrend = function () {
        window.OpenMnemo('Trends?' + props.trendparam);
        handleClose();
    };

    return (
        <div>
            <StyledMenu anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose}>
                <StyledMenuItem>
                    <ListItemText primary={props.itemname} />
                </StyledMenuItem>
                <StyledMenuItem onClick={openTrend}>
                    <ListItemIcon>
                        <Timeline fontSize="small" />
                    </ListItemIcon>
                    <ListItemText primary="Тренд" />
                </StyledMenuItem>
            </StyledMenu>
        </div>
    );
}
